module.exports = __webpack_public_path__ + "static/media/LiveRateIcon.d2774427.svg";